export const ExpressionViolationTypes = {
  SYNTAX: 'SYNTAX'
};
export const isSyntaxViolation = violation => violation.type === ExpressionViolationTypes.SYNTAX;
export const isExpressionViolation = violation => isSyntaxViolation(violation);